// Ref: https://blog.speedvitals.com/delay-javascript/#Add_JS_Delay_Code
// Charge les <script delay="URL"> à la première interaction ou après 5 s.
(function () {
	const autoLoadDuration = 5; //In Seconds
	const eventList = [
		'keydown',
		'mousemove',
		'wheel',
		'touchmove',
		'touchstart',
		'touchend',
	];
	const autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);

	eventList.forEach(function (event) {
		window.addEventListener(event, triggerScripts, {passive: true});
	});

	function triggerScripts() {
		runScripts();
		clearTimeout(autoLoadTimeout);
		eventList.forEach(function (event) {
			window.removeEventListener(event, triggerScripts);
		});
	}

	function runScripts() {
		document.querySelectorAll('script[delay]').forEach(function (scriptTag) {
			scriptTag.setAttribute('src', scriptTag.getAttribute('delay'));
		});
	}
})();
